/* eslint-disable array-callback-return */
import React, { useContext } from "react";
import { useQuery } from "react-query";
import MemberContext from "../../../context/MemberProvider";
import { getLedgerByPfNumber } from "../../../api/apiServices";
import { format } from "date-fns";
const dateFormat = "dd-MM-yyyy";

const MemberPaymentTransactions = () => {
	const { mem } = useContext(MemberContext);
	const pfNumber = mem?.pfNumber;

	const {
		isLoading,
		isError,
		error,
		data: memLedger,
	} = useQuery(["memLedger", pfNumber], () => getLedgerByPfNumber(pfNumber));

	const summaryPay = memLedger?.paymentSummary;
	let totalPayment = 0;
	let paymentData = [];

	// Member Payments
	
		memLedger?.payment.map((paymtData) => {
			totalPayment += paymtData.payment_amount;
			let payData = {
				year: paymtData.year,
				payment_date: paymtData.payment_date,
				payment_type: paymtData.payment_type,
				description: paymtData.description,
				receipt_number: paymtData.receipt_number,
				payment_amount: paymtData.payment_amount.toLocaleString(
					undefined,
					{ minimumFractionDigits: 2 }
				),
			};
			paymentData.push(payData);
		});
	

	const paymtSummary = (
		<>
			<>
				<div className="table-responsive lg">
					<table className="table table-borderless table-hover table-striped">
						<thead>
							<tr>
								<th style={{ textAlign: "center" }}>Year</th>
								<th style={{ textAlign: "center" }}>
									Payment Date
								</th>
								<th style={{}}>Receipt Number</th>
								<th style={{}}>Payment Type</th>
								<th style={{ textAlign: "right" }}>
									Amount (GHS)
								</th>
							</tr>
						</thead>
						<tbody>
							{summaryPay?.map((paymt, index) => (
								<>
									<tr key={index}>
										<td style={{ textAlign: "center" }}>
											{paymt?.year}
										</td>
										<td style={{ textAlign: "center" }}>
											{format(
												new Date(paymt?.payment_date),
												dateFormat
											)}
										</td>
										<td style={{}}>
											{paymt?.receipt_number}{" "}
										</td>

										<td style={{}}>
											{paymt?.payment_type}
										</td>
										<td style={{ textAlign: "right" }}>
											{paymt?.payment_amount.toLocaleString(
												undefined,
												{ minimumFractionDigits: 2 }
											)}{" "}
										</td>
									</tr>
								</>
							))}
						</tbody>
					</table>
				</div>
			</>
		</>
	);

	let content;
	if (isLoading) {
		content = <p>Loading Member Payment Transactions...</p>;
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<>
				<div className="table-responsive lg">
					<table className="table table-borderless table-hover table-striped">
						<thead>
							<tr>
								<th style={{ textAlign: "center" }}>Year</th>
								<th style={{ textAlign: "center" }}>
									Payment Date
								</th>
								<th style={{}}>Receipt Number</th>
								<th style={{}}>Payment Type</th>
								<th style={{ whiteSpace: "nowrap" }}>
									Description
								</th>
								<th style={{ textAlign: "right" }}>
									Amount (GHS)
								</th>
							</tr>
						</thead>
						<tbody>
							{paymentData?.map((payment) => (
								<tr key={payment.id}>
									<td style={{ textAlign: "center" }}>
										{payment.year}
									</td>
									<td style={{ textAlign: "center" }}>
										{format(
											new Date(payment.payment_date),
											dateFormat
										)}
									</td>
									<td style={{ textAlign: "left" }}>
										{payment.receipt_number}
									</td>
									<td style={{ textTransform: "uppercase" }}>
										{payment.payment_type}
									</td>
									<td style={{ whiteSpace: "nowrap" }}>
										{payment.description}
									</td>
									<td style={{ textAlign: "right" }}>
										{payment.payment_amount.toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}
									</td>
								</tr>
							))}
							<tr>
								<td colSpan="6"></td>
							</tr>
							<tr>
								<td
									colSpan="5"
									className="border-bottom"
									style={{
										width: "55%",
										textAlign: "left",
										fontSize: "16px",
										fontWeight: "700",
										color: "darkred",
									}}
								>
									TOTAL PAYMENT
								</td>
								{totalPayment < 0 ? (
									<td
										className="border-bottom"
										style={{
											width: "40%",
											textAlign: "right",
											fontSize: "16px",
											fontWeight: "700",
											color: "darkred",
										}}
									>
										(
										{(totalPayment * -1).toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}
										){" "}
									</td>
								) : (
									<td
										className="border-bottom"
										style={{
											width: "40%",
											textAlign: "right",
											fontSize: "16px",
											fontWeight: "700",
											color: "darkred",
										}}
									>
										{totalPayment.toLocaleString(
											undefined,
											{ minimumFractionDigits: 2 }
										)}{" "}
									</td>
								)}
							</tr>
							<tr>
								<td
									colSpan="7"
									style={{
										width: "95%",
										borderBottom: "5px",
									}}
								></td>
							</tr>
						</tbody>
					</table>
				</div>
			</>
		);
	}

	return (
		<>
			<section className="content-header">
				<h1>Member Payment Transactions </h1>
			</section>
			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>
												Member Payment Transaction
												Summary
											</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{paymtSummary}</div>
							<div className="panel-footer"></div>
						</div>
						<div className="panel panel-default panel-br-4">
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">
											<span>
												Member Payment Transaction
												Details
											</span>
										</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">
								<fieldset className="col-md-12">
									{content}
								</fieldset>
							</div>
							<div className="panel-footer"></div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};

export default MemberPaymentTransactions;
